"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.regexp.split.js");

var _classnames = _interopRequireDefault(require("classnames"));

var _stylesModule = _interopRequireDefault(require("../styles.module.css"));

/**
 * A utility that acts like classNames[1], but also maps classNames to local
 * CSS Module names from styles.module.css. If a given className is not found
 * in styles.module.css, an error is thrown.
 *
 * [1]: https://www.npmjs.com/package/classnames
 *
 * Example:
 *
 *   classes('padding-all-2', {
 *     'margin-bottom-2': !isLastItem,
 *   })
 */
var classes = function classes() {
  return _classnames.default.apply(void 0, arguments).split(/\s+/).filter(Boolean).map(function (inputClassName) {
    var mappedClassName = _stylesModule.default[inputClassName];

    if (!mappedClassName) {
      throw new Error("Invalid base-styles rule: ".concat(JSON.stringify(inputClassName)));
    }

    return mappedClassName;
  }).join(' ');
};

var _default = classes;
exports.default = _default;